import { useTranslation } from 'react-i18next';

import { Box, SparklyVideoActiveOutline, SparklyVideoOutline } from '@bonusly/design-system';
import { useDispatch } from '@bonusly/events';

import { useActionInput } from '../../context';
// Won't successfully pass type check if I reference a file in monarch using relative path but looking to consolate types
// import { VideoRecordingEvent } from '../../../../../events';
import { VideoRecordingEvent } from '../../events';
import { useIsEnabled } from '../../hooks/use-is-enabled';
import { DecorationButton } from './decoration-button';

export const RecordVideoButton = () => {
	const isEnabled = useIsEnabled('video-recording');
	const { t } = useTranslation('action_input');
	const dispatch = useDispatch();
	const { context } = useActionInput();

	if (!isEnabled) {
		return null;
	}

	const openVideoRecordingModal = () => {
		dispatch(VideoRecordingEvent.OpenModal, { contextType: context });
	};

	return (
		<DecorationButton
			label={t('decorations.record_video_tooltip')}
			onClick={openVideoRecordingModal}
			color="blue.400"
			_hover={{
				background: '#1670DF14',
				color: 'blue.500',
			}}
		>
			<Box
				sx={{
					display: 'inline-flex',
					alignItems: 'center',
					'& > .default-icon': { display: 'inline-block' },
					'& > .hover-icon': { display: 'none' },
					_hover: {
						'& > .default-icon': { display: 'none' },
						'& > .hover-icon': { display: 'inline-block' },
					},
				}}
			>
				<SparklyVideoOutline size="lg" className="default-icon" />
				<SparklyVideoActiveOutline size="lg" className="hover-icon" />
			</Box>
		</DecorationButton>
	);
};
